<template>
    <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div v-if="show" class="fixed inset-0 z-[200] flex items-center justify-center p-4 sm:p-6">
            <!-- Backdrop -->
            <div @click="$emit('cancel')" class="absolute inset-0 bg-[#0b141a]/80 backdrop-blur-[2px]"></div>

            <!-- Modal Content -->
            <div class="relative w-full max-w-sm bg-[#233138] rounded-3xl shadow-2xl overflow-hidden border border-white/5 animate-in zoom-in-95 duration-200">
                <div class="p-8">
                    <div class="flex flex-col items-center text-center">
                        <div class="h-16 w-16 bg-red-500/10 rounded-full flex items-center justify-center mb-6 ring-8 ring-red-500/5">
                            <TrashIcon class="h-8 w-8 text-red-500" />
                        </div>
                        <h3 class="text-xl font-bold text-white mb-2">Discard files?</h3>
                        <p class="text-white/60 text-sm leading-relaxed">
                            Are you sure you want to discard the selected files? This action cannot be undone.
                        </p>
                    </div>
                </div>

                <div class="p-6 bg-[#1e2a30] flex flex-col space-y-3">
                    <button 
                        @click="$emit('confirm')" 
                        class="w-full py-4 bg-red-500 hover:bg-red-600 text-white rounded-2xl font-bold text-sm uppercase tracking-widest transition-all active:scale-[0.98] shadow-lg shadow-red-500/10"
                    >
                        Discard Files
                    </button>
                    <button 
                        @click="$emit('cancel')" 
                        class="w-full py-4 bg-transparent hover:bg-white/5 text-white/70 hover:text-white rounded-2xl font-bold text-sm uppercase tracking-widest transition-all active:scale-[0.98]"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { TrashIcon } from "@heroicons/vue/outline";

export default {
    name: 'DiscardConfirmationModal',
    components: {
        TrashIcon
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    emits: ['confirm', 'cancel']
}
</script>
